var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ProfilData'),(_vm.$route.meta.showUpdatePasswordDialog)?[_c('PasswordDialog')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }